// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"106ffba5","163":"b84ecaf9","164":"c70e0829","267":"106ffba5","388":"0ed40da5","419":"54000ad3","599":"a2989e25","895":"3dbab005","915":"9f728db9"}[chunkId] + ".css";
};